<ng-container *ngIf="!isMobileRender">
  <zip-co-header></zip-co-header>
</ng-container>

<app-new-design-variant
  *ngFor="let giftCard of giftCardArray$ | async"
  [giftCard]="giftCard"
  [cardAvailability]="giftCard.cardTypeStatus === 'AVAILABLE'"
  [showBackButton]="true"
  [(selectedDenomination)]="selectedDenomination"
  [isMobileRender]="isMobileRender"
  (back)="continueShopping()"
  (continueShopping)="continueShopping()"
  (checkoutForYourself)="checkoutForYourself(1)"
  (checkoutForFriend)="checkoutForFriend(1)"
  (browseClick)="viewCard($event)"
  [isAmazonGiftCard]="giftCard.id === 'AUBHNAMZC001'"
  [isBigWGiftCard]="isBigWGiftCard | async"
  [browseCards]="browseGiftCards$ | async"
  [importantContent]="giftCard.importantContent"
  [showGiftCardSuffix]="giftCard.id !== 'VODAFONE_PRE_PAID_TOP_UP'"
  [isCaltexCard]="isCaltexCard$ | async"
  [(buyType)]="buyType"
></app-new-design-variant>

<ng-container *ngIf="!isMobileRender">
  <app-footer></app-footer>
</ng-container>

<ng-container *ngIf="isMobileRender">
  <app-mobile-footer (back)="back()"></app-mobile-footer>
</ng-container>
